/* Essence & Flamme, design v2 : menu téléphone, galerie, panier (une seule pièce de chaque),
   mot cadeau, filtres de la collection, accordéons, onglets du contact, barre d'achat. */
(function () {
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Menu téléphone : le menu ouvert pousse le contenu */
  var head = $('#e2-head');
  var burger = $('[data-e2-burger]');
  var menu = $('#e2-menu');
  if (burger && menu) {
    burger.addEventListener('click', function () {
      var open = menu.hidden;
      menu.hidden = !open;
      head.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Compteur du panier dans l'en-tête */
  function setCount(n) {
    $$('[data-e2-count]').forEach(function (b) { b.textContent = n; b.classList.toggle('is-full', n > 0); });
  }

  /* Galerie : 2 photos en fondu, toucher à gauche / à droite, vignettes */
  $$('[data-e2-gal]').forEach(function (gal) {
    var imgs = $$('.e2-gal__main img', gal);
    var main = $('.e2-gal__main', gal);
    var dots = $$('.e2-gal__dots span', gal);
    var thumbs = $$('[data-e2-thumb]', gal);
    var label = $('[data-e2-label]', gal);
    var cur = 0;
    function show(i) {
      if (!imgs.length) return;
      cur = (i + imgs.length) % imgs.length;
      imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === cur); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === cur); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-pressed', k === cur ? 'true' : 'false'); });
      if (label) label.textContent = label.getAttribute('data-l' + cur) || '';
    }
    $$('[data-e2-step]', gal).forEach(function (b) {
      b.addEventListener('click', function () { show(cur + parseInt(b.getAttribute('data-e2-step'), 10)); });
    });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    /* Glisser du doigt (téléphone) ou à la souris pour changer de photo */
    var x0 = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) {
          show(cur + (dx < 0 ? 1 : -1));
          main.dataset.swiped = '1';
          setTimeout(function () { delete main.dataset.swiped; }, 350);
        }
      });
      main.addEventListener('click', function (e) {
        if (main.dataset.swiped) { e.stopPropagation(); e.preventDefault(); delete main.dataset.swiped; }
      }, true);
      main.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') show(cur + 1);
        if (e.key === 'ArrowLeft') show(cur - 1);
      });
    }
  });

  /* Ajout au panier : une seule fois par pièce (pièce unique) */
  var pdp = $('[data-e2-product]');
  if (pdp) {
    var variant = pdp.getAttribute('data-variant');
    var addBtns = $$('[data-e2-add]', pdp);
    var busy = false;
    function markIn() {
      addBtns.forEach(function (b) {
        b.classList.add('is-in');
        b.style.background = 'var(--e2-braise)';
        b.style.borderColor = 'var(--e2-braise)';
        b.textContent = b.hasAttribute('data-e2-short') ? 'Dans le panier ✓' : 'Dans votre panier ✓';
      });
    }
    function add() {
      if (busy || addBtns.some(function (b) { return b.classList.contains('is-in'); })) return;
      busy = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); markIn(); })
        .catch(function () {
          addBtns.forEach(function (b) { b.textContent = 'Pièce indisponible'; });
        })
        .then(function () { busy = false; });
    }
    var form = $('form[action*="/cart/add"]', pdp);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    addBtns.forEach(function (b) { if (b.type !== 'submit') b.addEventListener('click', add); });

    /* Mot cadeau : gardé dans le panier (attribut « Mot cadeau »), affiché sur la page panier */
    var giftToggle = $('[data-e2-gift-toggle]', pdp);
    var giftBox = $('#e2-gift');
    var gift = $('[data-e2-gift]', pdp);
    var giftCount = $('[data-e2-gift-count]', pdp);
    var t;
    if (giftToggle && giftBox) {
      giftToggle.addEventListener('click', function () {
        var open = giftBox.hidden;
        giftBox.hidden = !open;
        giftToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && gift) gift.focus();
      });
    }
    if (gift) {
      gift.addEventListener('input', function () {
        if (giftCount) giftCount.textContent = gift.value.length;
        clearTimeout(t);
        t = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { 'Mot cadeau': gift.value.slice(0, 240) } })
          });
        }, 500);
      });
    }

    /* Barre d'achat : toujours visible sur téléphone (CSS), sur ordinateur quand le bouton principal sort de l'écran */
    var bar = $('[data-e2-buybar]');
    var anchor = $('#e2-add');
    if (bar && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0];
        bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(anchor);
    }
  }

  /* Accordéons : un seul ouvert à la fois */
  $$('[data-e2-accs]').forEach(function (box) {
    var items = $$('details', box);
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  });

  /* Filtres de la collection */
  var col = $('[data-e2-collection]');
  if (col) {
    var cards = $$('[data-e2-grid] .e2-card', col);
    var label = $('[data-e2-count-label]', col);
    $$('[data-e2-filter]', col).forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-e2-filter');
        $$('[data-e2-filter]', col).forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        var n = 0;
        cards.forEach(function (c) {
          var on = f === 'tout' || c.getAttribute('data-cat') === f;
          c.hidden = !on;
          if (on) n++;
        });
        if (label) label.textContent = n + (n > 1 ? ' pièces' : ' pièce');
      });
    });
  }

  /* Onglets du contact */
  $$('[data-e2-tabs]').forEach(function (box) {
    var tabs = $$('[data-e2-tab]', box);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.getAttribute('data-e2-tab');
        tabs.forEach(function (o) {
          var on = o === tab;
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
          o.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        $$('[data-e2-panel]', box).forEach(function (p) { p.hidden = p.getAttribute('data-e2-panel') !== name; });
      });
    });
  });
})();
